import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWhiteboard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWhiteboard1"><Path d="M16.5 21.5L15.1263 18.7526M7.5 21.5L8.87369 18.7526M12 20.5V18.7526M12 4.5H2.5V18.5H21.5V4.5H12ZM12 4.5V2.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconWhiteboard1;
